import { Box, Button, Circle, Image, Progress, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  calculateDateRange,
  convertToMinutes,
  quizStarted,
  resetSelectedQuiz,
  setAutocompleteVisibility,
} from "../../redux/actions/action";
import { loadQuizQuestions, loadSelectedQuiz } from "../../redux/api/apiCalls";
import { ReactComponent as Calendar } from "../../svg/calendar.svg";
import { ReactComponent as Clock } from "../../svg/clock.svg";
import { ReactComponent as PlayButton } from "../../svg/play-button.svg";
import { ReactComponent as Retries } from "../../svg/Retries.svg";
import { useHistory } from "react-router-dom";

export default function QuizDetails(props) {
  const {
    selectedQuiz,
    isLoading: selectedQuizIsLoading,
    /*selectedQuizError,*/
  } = useSelector((state) => state.selectedQuiz);

  const dispatch = useDispatch();
  const history = useHistory();

  console.log(selectedQuiz)

  const getQuizFromParams = () => {
    dispatch(loadSelectedQuiz(props.match.params.id));
  };

  const playQuizHandler = () => {
    dispatch(loadQuizQuestions(props.match.params.id));
    dispatch(quizStarted());
    history.push({
      pathname: `/test-attempt`,
      state: { attemptsLeft: selectedQuiz.no_of_attempts_left }
    });
  };

  useEffect(() => {
    getQuizFromParams();
    return () => dispatch(resetSelectedQuiz())
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      px="1rem"
      w="95%"
      minH="90vh"
      onClick={(e) => {
        e.stopPropagation()
        dispatch(setAutocompleteVisibility(false))
      }}
    >
      {selectedQuizIsLoading && !selectedQuiz ? (
        <Progress size="xs" isIndeterminate width="100%" mt="3rem" />
      ) : (
        <>
          <Text
            fontSize="14px"
            fontWeight="600"
            style={{ fontFamily: "Mulish, sans-serif" }}
            pt="2rem"
            color="#999999"
            textTransform='capitalize'
          >
            Home/Quiz/{selectedQuiz?.title}
          </Text>
          <Text
            fontSize={["20px", "25px", "30px", "40px"]}
            d={["none", "none", "none", "flex"]}
            fontWeight="900"
            style={{ fontFamily: "Mulish, sans-serif" }}
            textTransform='capitalize'
          >
            {selectedQuiz?.title}
          </Text>
          <Box
            width="100%"
            justifyContent={[
              "space-between",
              "space-between",
              "space-between",
              "flex-start",
            ]}
            alignItems="center"
            style={{ fontFamily: "Mulish, sans-serif", gap: "4rem" }}
            flexWrap={["wrap", "wrap", "wrap", "nowrap"]}
            fontSize={['14px', '14px', '14px', '15px', '16px']}
            fontWeight="600"
            d="flex"
            color="#666666"
            my="3"
          >
            <Box
              d="flex"
              justifyContent="center"
              alignItems="center"
              my={["1rem", "1rem", "1rem", "0"]}
            >
              <Calendar />
              <Text ml="2">
                {
                  selectedQuiz?.start_date ?
                    calculateDateRange(
                      selectedQuiz.start_date,
                      selectedQuiz.end_date.split(" ")[0]
                    ) : 'N/A'
                }
              </Text>
            </Box>
            <Box
              d="flex"
              justifyContent="center"
              alignItems="center"
              my={["1rem", "1rem", "1rem", "0"]}
            >
              <Clock />
              <Text ml="2">
                {
                  selectedQuiz?.time_duration ?
                    `${convertToMinutes(selectedQuiz?.time_duration)} Mins` : 'N/A'
                }

              </Text>
            </Box>
            <Box
              d="flex"
              justifyContent="center"
              alignItems="center"
              my={["1rem", "1rem", "1rem", "0"]}
            >
              <Retries />
              <Text ml="2">{selectedQuiz?.no_of_attempts_left} Attempts</Text>
            </Box>
          </Box>
          <Text
            fontSize="20px"
            fontWeight="700"
            style={{ fontFamily: "Mulish, sans-serif" }}
          >
            About this quiz
          </Text>
          <Box
            d="flex"
            justifyContent={["center", "center", "center", "flex-start"]}
            px="2"
            alignItems={["flex-start", "flex-start", "flex-start", "center"]}
            flexDir={["column", "column", "column", "row"]}
            width="100%"
            my="1rem"
          >
            {selectedQuiz?.course_id && (
              <Box
                d="flex"
                justifyContent="flex-start"
                alignItems="center"
                pointerEvents="none"
                mr={["0", "0", "0", "3rem"]}
                mb={["1rem", "1rem", "1rem", "0"]}
              >
                <Circle size={["30px", "30px", "40px", "45px"]} mr="1rem">
                  <Image
                    src={selectedQuiz.courses.cover_image}
                    fallbackSrc={"https://source.unsplash.com/random/800x600"}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    borderRadius="50%"
                  />
                </Circle>
                <Box
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  d="flex"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="flex-start"
                >
                  <Text
                    fontWeight="700"
                    fontSize={["11px", "11px", "11px", "13px"]}
                    color="#33333380"
                    textTransform="uppercase"
                  >
                    Course
                  </Text>
                  <Text
                    fontWeight="700"
                    fontSize={["14px", "14px", "14px", "16px"]}
                    color="#333333"
                  >
                    {selectedQuiz.courses.title}
                  </Text>
                </Box>
              </Box>
            )}
            {selectedQuiz?.topic_id && (
              <Box
                d="flex"
                justifyContent="flex-start"
                alignItems="center"
                pointerEvents="none"
              >
                <Circle size={["30px", "30px", "40px", "45px"]} mr="1rem">
                  <Image
                    src={selectedQuiz.topics.cover_image}
                    fallbackSrc={"https://source.unsplash.com/random/800x600"}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    borderRadius="50%"
                  />
                </Circle>
                <Box
                  style={{ fontFamily: "Mulish, sans-serif" }}
                  d="flex"
                  flexDir="column"
                  justifyContent="center"
                  alignItems="flex-start"
                >
                  <Text
                    fontWeight="700"
                    fontSize={["11px", "11px", "11px", "13px"]}
                    color="#33333380"
                    textTransform="uppercase"
                  >
                    Topic
                  </Text>
                  <Text
                    fontWeight="700"
                    fontSize={["14px", "14px", "14px", "16px"]}
                    color="#333333"
                  >
                    {selectedQuiz.topics.title}
                  </Text>
                </Box>
              </Box>
            )}
          </Box>

          <Box
            dangerouslySetInnerHTML={{ __html: selectedQuiz?.description }}
            style={{ fontFamily: 'Mulish, sans-serif' }}
            lineHeight='32px'
            my='1rem'
            pl={selectedQuiz?.description.includes('<li>') && '2rem'}
          ></Box>
          
          {history.location.state.filter === "Upcoming" && (
            <Button
              bg="linear-gradient(90.57deg, #7B90F7 3.35%, #3E59DE 94.78%)"
              borderRadius="7px"
              // p='24px 61px 24px 51px'
              py={["16px", "16px", "16px", "24px"]}
              px={["28px", "28px", "30px", "51px"]}
              boxShadow="0px 4px 8px rgba(0, 0, 0, 0.1)"
              d="flex"
              justifyContent="center"
              alignItems="center"
              textTransform="uppercase"
              style={{ fontFamily: "Mulish, sans-serif", gap: "0.5rem" }}
              _hover={{
                bg: "linear-gradient(90.57deg, #6e81dd 3.35%, #3750c6 94.78%)",
              }}
              fontSize={["16px", "16px", "16px", "18px"]}
              fontWeight="800"
              color="#FFFFFF"
              onClick={playQuizHandler}
              mb="2rem"
            >
              <PlayButton width="22px" fill="white" /> Play
            </Button>
          )}
        </>
      )}

      {/* {!selectedQuizIsLoading && selectedQuizError && (
        <Text>{selectedQuizError}</Text>
      )} */}
    </Box>
  );
}
